//Compile with esbuild

require('./src/mobile.js'); //Mobile scripts
// require('./src/scrollEvents.js'); //Scroll events (GSAP)
//require('./src/custom-cursor.js'); //swiper.js
require('./src/carousels.js'); // Swiper scripts
require('./src/inquire-form.js'); // Form scripts
//require('./src/modals.js'); // Modal scripts
require('./src/navigation.js'); //Navigation scripts
require('./src/videos.js'); //Video scripts
require('./src/cookies.js'); //Cookie scripts
require('./src/map-panzoom.js'); //Panzoom scripts for map
require('./src/gallery.js'); //Gallery scripts
require('./src/team-auberge.js'); //Team auberge scripts
require('./src/residence-table'); //Residence table

const r = document.querySelector(':root');

//Document loaded event
document.addEventListener("DOMContentLoaded", function() {


	// scrollbarWidthSet();
	initScrollOut(); // Appear on scroll
	getWindowHeight(); // sets a variable for --vh
	splitText();


	// This prevents iOS zoom on focused form elements with font size smaller than 16px.
	// iOS 10+ allows pinch-zoom even if viewport is unscalaeable.
	// We feature detect those browsers and apply additional rules.
	if (
		window.CSS?.supports?.(
			'(font:-apple-system-body) and (-webkit-touch-callout:none) and (-webkit-tap-highlight-color:hotpink)'
		)
	) {
		const viewport = document.querySelector('meta[name="viewport"]');
		if (viewport !== null) {
			viewport.content = `${viewport.content},user-scalable=no`;
		}
	}


});

// Resize event
window.addEventListener('resize', () => {
	getWindowHeight();
});


function getWindowHeight() {
	let vh = window.innerHeight * 0.01;
	r.style.setProperty('--vh', `${vh}px`);
}

function getElementScrollbarWidth(element) {
	return element.offsetWidth - element.clientWidth;
}

function scrollbarWidthSet() {
	//Set a CSS variable with the scrollbar width
	let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
	r.style.setProperty('--scrollbar-width', scrollbarWidth);
}

function initScrollOut() { // Appear on scroll
	ScrollOut({
		targets: '[data-scroll]',
		offset: 0,
		// threshold:0,
		threshold:0.2,
		once: true,
	});
	ScrollOut({ //repeating
		targets: '[data-scroll-r]',
		once: false,
	});
}

function splitText() {
	//splitting.js
	Splitting({
		by: 'chars'
	});
}